<script setup>
import { ref, computed, onMounted, nextTick, defineEmits } from 'vue';

const props = defineProps({
  x: { type: Number, default: 0 },
  y: { type: Number, default: 0 },
  centerAlign: { type: Boolean, default: false },
});
const emit = defineEmits(['close']);

const target = ref();

const left = ref(props.x);
const top = ref(props.y);

const style = computed(() => ({
  top: top.value + 'px',
  left: left.value + 'px',
}));

onMounted(() => {
  nextTick(() => {
    target.value.focus();
    
    if (props.centerAlign && target.value) {
      const popoverRect = target.value.getBoundingClientRect();
      left.value = props.x - popoverRect.width / 2;
      top.value = props.y - popoverRect.height / 2;
    }
  });
});
</script>

<template>
  <Teleport to="body">
    <div
      ref="target"
      class="fixed outline-none z-[9999] cursor-pointer"
      :style="style"
      tabindex="0"
      @blur="emit('close')"
    >
      <slot />
    </div>
  </Teleport>
</template>